import { createElement } from "react";
import { head, tail, isEmpty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { $007CNotEmpty$007C_$007C } from "../Shopfoo.Common/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { React_withKeyAuto_2B31D457 } from "../UI.js";
import { Feat, $007CUserCanAccess$007C_$007C } from "../Shopfoo.Domain.Types/Security.js";

function textCode(key, text) {
    return createElement("code", {
        key: `${key}-code`,
        className: "text-sm",
        children: `${text}`,
    });
}

function errorDetail(apiError_1, key, user) {
    let elems_2;
    const matchValue = apiError_1.ErrorDetail;
    let matchResult, errorDetail_1;
    if (matchValue != null) {
        if ($007CUserCanAccess$007C_$007C(new Feat(1, []), user) != null) {
            matchResult = 0;
            errorDetail_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const lines = ofArray(errorDetail_1.Exception.split("\n"));
            let patternInput;
            const matchValue_2 = apiError_1.ErrorCategory;
            patternInput = (($007CNotEmpty$007C_$007C(matchValue_2) != null) ? [textCode(key, matchValue_2), errorDetail_1.Exception] : (isEmpty(lines) ? [defaultOf(), undefined] : (isEmpty(tail(lines)) ? [textCode(key, head(lines)), undefined] : [textCode(key, head(lines)), join("\n", tail(lines))])));
            return createElement("div", createObj(Helpers_combineClasses("collapse", ofArray([["className", "collapse-arrow"], ["key", `${key}-collapse`], ["tabIndex", 0], ["className", "border"], (elems_2 = toList(delay(() => append(singleton(createElement("div", createObj(Helpers_combineClasses("collapse-title", ofArray([["key", `${key}-collapse-title`], ["children", reactApi.Children.toArray(["[Admin]", patternInput[0]])]]))))), delay(() => {
                let elems_1;
                const matchValue_4 = patternInput[1];
                if (matchValue_4 != null) {
                    return singleton(createElement("div", createObj(Helpers_combineClasses("collapse-content", ofArray([["key", `${key}-collapse-content`], (elems_1 = [React_withKeyAuto_2B31D457(createElement("p", {
                        children: [matchValue_4],
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))));
                }
                else {
                    return empty();
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }
        default:
            return defaultOf();
    }
}

export function apiError(key, apiError_1, user) {
    let elems_1, elems;
    return createElement("div", createObj(Helpers_combineClasses("alert", ofArray([["className", "alert-error"], ["key", `${key}-alert`], (elems_1 = [createElement("div", createObj(ofArray([["key", `${key}-alert-content`], (elems = [createElement("div", {
        key: `${key}-message`,
        className: "pb-2",
        children: apiError_1.ErrorMessage,
    }), errorDetail(apiError_1, key, user)], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
}

